export const V2ApiPath = '/v2API';
